import { render, staticRenderFns } from "./CommunityEdit.vue?vue&type=template&id=085f6ece&"
import script from "./CommunityEdit.vue?vue&type=script&lang=js&"
export * from "./CommunityEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports